import { Spinner } from 'react-bootstrap';

export default function Button({
  handleClick,
  text,
  disabled = false,
  classes = '',
  className,
  children,
  loading = false,
  type = 'button',
}) {
  return (
    <button
      onClick={handleClick}
      disabled={disabled || loading}
      className={className || `flex items-center justify-center gap-2 px-4 py-2 ${classes}`}
      type={type}
    >
      {loading && (
        <span className="inline-flex items-center">
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            className="me-2"
          />
        </span>
      )}
      {text}
      {children}
    </button>
  )
}
